
import { AirRoadBookingStateData } from '@/models/airRoad';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PendingStep extends Vue {
  @Prop(Object) bookingState!: AirRoadBookingStateData;
}
